import { CarouselImage, CreateCarouselImage } from '@/domains';
import { authorizedApi } from '../network/authorized-api';

export const getCarouselImages = (): Promise<CarouselImage[]> => authorizedApi.get<CarouselImage[]>('/carousel-images');

export const createCarouselImage = (data: CreateCarouselImage): Promise<CarouselImage> =>
  authorizedApi.post<CarouselImage>('/carousel-images', data);

export const deleteCarouselImage = (id: string): Promise<void> => authorizedApi.delete(`/carousel-images/${id}`);

